package amazon.lastmile.inject

import app.nestbridge.feature.messages.presentation.MessagesPresenterFactory
import com.slack.circuit.runtime.presenter.Presenter
import me.tatarka.inject.annotations.IntoSet
import me.tatarka.inject.annotations.Provides
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Origin(value = MessagesPresenterFactory::class)
public interface AppNestbridgeFeatureMessagesPresentationMessagesPresenterFactory {
  @Provides
  @IntoSet
  public fun provideMessagesPresenterFactoryFactoryMultibinding(messagesPresenterFactory: MessagesPresenterFactory): Presenter.Factory = messagesPresenterFactory
}
